import Button from '@mui/material/Button'
import React from 'react'

type Props = {
  closeHandler: () => void
}

const ContactsUploadSuccessActions: React.FC<Props> = ({ closeHandler }) => (
  <Button variant="outlined" onClick={closeHandler}>
    Close
  </Button>
)

export default ContactsUploadSuccessActions
